// extracted by mini-css-extract-plugin
export var container = "_hj-0";
export var content = "_hj-3";
export var customerTitle = "_hj-4";
export var empty = "_hj-5";
export var gray = "_hj-6";
export var header = "_hj-7";
export var info = "_hj-8";
export var loading = "_hj-2";
export var loadingCard = "_hj-9";
export var oneLine = "_hj-a";
export var personName = "_hj-e";
export var pillContainer = "_hj-b";
export var selected = "_hj-1";
export var text = "_hj-c";
export var twoLines = "_hj-d";
export var unread = "_hj-f";
export var unreadIndicator = "_hj-g";